function initEntryAnimations(){
    
    const   animation_class = 'smx-entry-animation',
            data_attibute   = 'smxAnimationEntry',
            items = document.querySelectorAll('.' + animation_class);


            documentEntryAnimation();
            documentExitAnimation();

    items.forEach((item) => {
        var animation_type = item.dataset[data_attibute];

        assignAnimationStyle(item, animation_type, false);
        

        let callback = (entry) => {
            var is_intersecting = entry[0].isIntersecting;
            assignAnimationStyle(item, animation_type, is_intersecting);
        }

        let options,
            observer,
            target;

        options = {
            threshold: [0.5],
        }
 
        observer = new IntersectionObserver(callback, options);
        target = item;
        observer.observe(target);

    });

}

function documentExitAnimation(){
    const selectors = ['a', '.smx-new-page'];
    selectors.forEach((selector) => {
        var items = document.querySelectorAll(selector);

        items.forEach((item) => {
            item.classList.add('magic-hover');
            item.addEventListener('click', ()=>{
                var href = item.getAttribute('href');
                if(href){
                    if(href.includes('http')){
                        document.body.classList.add('smx-page-changing');
                    }
                }else{
                    document.body.classList.add('smx-page-changing');
                }
                
            });
        });
    });
}

function documentEntryAnimation(){

    const current_url = window.location.href;
    

        document.documentElement.style.scrollBehavior = "unset";
        document.body.classList.add('smx-page-loaded');
        const timing = getComputedStyle(document.documentElement).getPropertyValue('--smx-timing-normal') * 1000;
        
    if( ! current_url.includes( '#' ) ){
        setTimeout(()=>{
            window.scrollTo(0,0);
            document.documentElement.style.scrollBehavior = "smooth";
        }, timing);

    }

}

function assignAnimationStyle(HTMLelement, animation_type, is_intersecting){
    switch(animation_type){
        case 'fade__bottom_top':
            if(is_intersecting){
                
                HTMLelement.style.bottom = 0;
                HTMLelement.style.opacity = 1;
            }else{
                setTimeout( ()=>{
                    HTMLelement.style.bottom = "-5rem";
                }, 10 );
                HTMLelement.style.opacity = 0;
            }
            break;
        default:
            if(is_intersecting){
                
                HTMLelement.style.bottom = 0;
                HTMLelement.style.opacity = 1;
            }else{
                setTimeout( ()=>{
                    HTMLelement.style.bottom = "-5rem";
                }, 10 );
                HTMLelement.style.opacity = 0;
            }
            break;
    }
}

export default { initEntryAnimations }